const ExtendedLabel = require('ExtendedLabel');
const BasePrizeController = require('BasePrizeController');
const ParticleManager = require('ParticleManager');
const CameraController = require('CameraController');
const FrameController = require('FrameController');
const AudioManager = require('AudioManager');
const AudioMap = require('AudioMap');

const WIN_TRESHOLDS = [1, 5, 10, 20, 40, 80];
const ANIMATION_DURATION = [1, 1, 3, 4, 5, 9,14];
const PRIZE_REMAIN_DURATION = [0.6, 1, 1, 2, 2.5, 3, 4];
const PRIZE_HIDE_DURATION = 0.2;

const State = cc.Enum({
    PROGRESS: 'progress',
    SHOW: 'show',
    NONE: 'none'
});

cc.Class({
    extends: BasePrizeController,

    properties: {
        coinParticle: ParticleManager,
        frameController: FrameController,
        cameraController: CameraController,
        overlay: cc.Node,
        label: ExtendedLabel,
        labelContainer: cc.Node,

        font1: cc.BitmapFont,
        font2: cc.BitmapFont,
        font3: cc.BitmapFont
    },

    start () {
        this.state = State.NONE;
        this.winThresholds = WIN_TRESHOLDS;
        this.audioManager = cc.find('AudioManager').getComponent(AudioManager);
        this.audioMap = cc.find('AudioMap').getComponent(AudioMap);
        this.targetScale = .8;
        this.label.node.on('checkpoint', ({ checkpoint }) => {
            this._onCheckpointReached(checkpoint);
        });
        this.node.active = true;
        this.label.setFontData(this.font1, 20);
    },

    _onBigPrizeCheckPointReached (checkpoint) {
        switch (checkpoint) {
            case 0:
                this.label.setFontData(this.font2, 20);
                this.audioManager.stopSfx(this.loopApplauseId);
                this.audioMap.playSfx('winCountUpAmountJump');
                this.frameController.show(0);
                this.coinParticle.play(30, 800);
                break;
            case 1:
                this.label.setFontData(this.font2, 20);
                this.audioManager.stopSfx(this.loopApplauseId);
                this.audioMap.playSfx('winMegaThreshold');
                this.frameController.show(1);
                this.coinParticle.play(40, 900);
                break;
            case 2:
                this.label.setFontData(this.font2, 20);
                this.audioManager.stopSfx(this.loopApplauseId);
                this.audioMap.playSfx('winEpicThreshold');
                this.frameController.show(2);
                this.coinParticle.play(50, 1000);
                break;
        }
        this.label.node.runAction(cc.sequence(
            cc.scaleTo(0.1, 0.3, 0.3),
            cc.scaleTo(0.1, 1.3, 1.3),
            cc.scaleTo(0.2, 1, 1).easing(cc.easeBackOut())
        ));
    },

    _onSmallPrizeCheckPointReached (checkpoint) {
        this.label.setFontData(this.font1, 20);
        switch (checkpoint) {
            case 0:
                this.audioManager.stopSfx(this.loopApplauseId);
                this.audioMap.playSfx('winCountUpAmountJump');
                break;
            case 1:
                this.audioManager.stopSfx(this.loopApplauseId);
                this.audioMap.playSfx('winCountUpAmountJump');
                break;
        }
        this.label.node.runAction(cc.sequence(
            cc.scaleTo(0.1, 0.3, 0.3),
            cc.scaleTo(0.1, 1.3, 1.3),
            cc.scaleTo(0.2, 1, 1).easing(cc.easeBackOut())
        ));
    },

    finishAnimation () {
        this.isSlamStop = true;
        if (this.state === State.PROGRESS) {
            this._onCheckpointReached(this.checkPointPeak - 1);
            this.label.finishProgress();
            // this.node.stopAllActions();
            this.labelContainer.setScale(this.targetScale, this.targetScale);
        } else if (this.state === State.SHOW) {
            this.unscheduleAllCallbacks();
            this._hidePrize();
        }
    },

    showPrize (prize, betAmount) {
        return new Promise((resolve) => {
            if (!prize) {
                resolve();
                return;
            }

            this.state = State.PROGRESS;
            this.node.once('hidePrize', resolve);
            this.node.active = true;
            this.prize = prize;

            let scale = 1;
            let l = prize.toString().length;
            if (l < 4) {
                scale = 0.85;
            } else if (l < 6) {
                scale = 0.7;
            } else if (l < 8) {
                scale = 0.65;
            } else {
                scale = 0.5;
            }
            this.labelContainer.scale = scale;
            this.labelContainer.y = 0;
            this.betAmount = betAmount;
            const tr = 4;
            const level = this._checkWinningLevel(prize, betAmount);
            this.level = level;
            this._playAudioSfx(level);

            let winPromise = Promise.resolve();
            const checkpoints = [];
            this._onCheckpointReached = level < tr ? this._onSmallPrizeCheckPointReached : this._onBigPrizeCheckPointReached;

            this.checkPointPeak = level < tr ? level : level - 3;

            for (let i = 1; i < this.checkPointPeak ; i++) {
                checkpoints.push(i / this.checkPointPeak  * prize);
            }

            this.node.emit('bigWinAnimationStart', level > 3);
            switch (level) {
                case 0:
                    this.label.setNumber(prize);
                    this._onSmallPrizeCheckPointReached(0);
                    break;
                case 1:
                    this.label.startStamp(0.1, 0.1, prize);
                    this._onSmallPrizeCheckPointReached(0);
                    break;
                case 2:
                    winPromise = this._showProgressWinning(
                        prize,
                        ANIMATION_DURATION[level],
                        1 * scale,
                        checkpoints
                    );
                    this.scheduleOnce(() => {
                        this.node.emit('winAnimationSetSlamStop');
                    }, .3);
                    this._onSmallPrizeCheckPointReached(0);
                    break;
                case 3:
                    winPromise = this._showProgressWinning(
                        prize,
                        ANIMATION_DURATION[level],
                        1.1 * scale,
                        checkpoints
                    );
                    this.scheduleOnce(() => {
                        this.node.emit('winAnimationSetSlamStop');
                    }, .3);
                    this._onSmallPrizeCheckPointReached(0);
                    break;
                case 4:
                    winPromise = this._showProgressWinning(
                        prize,
                        ANIMATION_DURATION[level],
                        1.1 * scale,
                        checkpoints
                    );
                    this._onBigPrizeCheckPointReached(0);
                    this.scheduleOnce(() => {
                        this.node.emit('winAnimationSetSlamStop');
                    }, .3);
                    break;
                case 5:
                    winPromise = this._showProgressWinning(
                        prize,
                        ANIMATION_DURATION[level],
                        1.2 * scale,
                        checkpoints
                    );
                    this._onBigPrizeCheckPointReached(0);
                    this.scheduleOnce(() => {
                        this.node.emit('winAnimationSetSlamStop');
                    }, .3);
                    break;
                case 6:
                    winPromise = this._showProgressWinning(
                        prize,
                        ANIMATION_DURATION[level],
                        1.3 * scale,
                        checkpoints
                    );
                    this._onBigPrizeCheckPointReached(0);
                    this.scheduleOnce(() => {
                        this.node.emit('winAnimationSetSlamStop');
                    }, .3);
                    break;
            }
            winPromise.then(() => {
                this.label.node.stopAllActions();
                // this.label.node.setPosition(0, 0);
                this.audioManager.stopSfx(this.loopId);
                this.audioManager.fadeOutSfx(1000, this.winSfx);
                this._playAudioEndSfx(level);

                this.audioManager.stopSfx(this.loopCoinId);

                this.state = State.SHOW;
                // resolve the promise for smaller win levels to enable the spin button immediately
                this.scheduleOnce(() => {

                    this._hidePrize();
                }, this.isSlamStop ? PRIZE_REMAIN_DURATION[level] / 2 : PRIZE_REMAIN_DURATION[level]);
            });
        });

    },

    _hidePrize () {
        this.isSlamStop = false;
        this.coinParticle.stop();
        this.frameController.hide();
        if (this.overlay.active) {
            cc.tween(this.overlay).to(PRIZE_HIDE_DURATION, { opacity: 0 }).start();
        }
        this.label.hide(PRIZE_HIDE_DURATION).then(() => {
            this.node.setScale(1, 1);
            this.node.active = false;
            this.node.emit('hidePrize');
            this.overlay.active = false;
        });
    },

    _playAudioSfx (level) {
        const random = Math.random();
        switch (level) {
            case 0:
                this.winSfx = this.audioMap.playSfx('winSubMiniGeneric2');
                break;
            case 1:
                this.winSfx = this.audioMap.playSfx(Math.random() > .5? 'win2A': 'win2B');
                break;
            case 2:
                this.winSfx = this.audioMap.playSfx('win3');
                break;
            case 3:
                this.winSfx = this.audioMap.playSfx('win4');
                break;
            case 4:
                this.winSfx = this.audioMap.playSfx('winBig');
                break;
            case 5:
                this.winSfx = this.audioMap.playSfx('winMega');
                break;
            case 6:
                this.winSfx = this.audioMap.playSfx('winEpic');
                break;
        }
    },

    _playAudioEndSfx (level) {
        switch (level) {
            case 2:
                this.audioMap.playSfx('win3End');
                break;
            case 3:
                this.audioMap.playSfx('win4End');
                break;
            case 4:
                this.audioMap.playSfx('winBigEnd');
                break;
            case 5:
                this.audioMap.playSfx('winMegaEnd');
                break;
            case 6:
                this.audioMap.playSfx('winEpicEnd');
                break;
        }
    },

    _showProgressWinning (score, duration, targetScale, checkpoints) {
        return new Promise((resolve) => {
            this.targetScale = targetScale;
            this.label.startProgress(duration, score, checkpoints).then(() => {
                this.audioManager.stopSfx(this.countUpLoop);
                this.countUpLoop = null;
                resolve();
            });
            // if (this.level > 3) {
            //     this.frameController.show(0);
            //     this.overlay.active = true;
            //     this.overlay.opacity = 0;
            //     const opacity = { opacity: this.level * 32 };
            //     cc.tween(this.overlay).to(duration, opacity).start();
            //     // fade in the sfx faster for bigger wins
            //     this.audioManager.fadeSound(0, 1, 500, this.totalSfx);
            //     this.coinParticle.play(25, 500);
            // } else {
            //     this.audioManager.fadeSound(0, 1, 4000, this.totalSfx);
            // }
            this.countUpLoop = this.audioMap.playSfx('winCountUpDigits', -1);

            cc.tween(this.labelContainer).to(duration, { scale: this.targetScale }).start();
            // this.node.runAction(cc.scaleTo(duration, this.targetScale, this.targetScale));
        });
    }
});
